import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const resolveUrl = (u) => (u && u.startsWith("/") ? `${BACKEND}${u}` : u);

/**
 * Portfolio image with anti-download friction:
 *  - context menu (right-click) disabled
 *  - drag-to-desktop disabled
 *  - transparent overlay absorbs pointer events so long-press on mobile can't save
 *  - user-select disabled
 *
 * These stop casual saving. Determined actors with devtools/screenshots
 * cannot be blocked on the web — watermarking (server-side) is the second layer.
 */
export const ProtectedImage = ({ src, alt = "", className = "", imgClassName = "", loading = "lazy", ...rest }) => {
  return (
    <div
      className={`protected-media ${className}`}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      {...rest}
    >
      <img
        src={resolveUrl(src)}
        alt={alt}
        draggable={false}
        loading={loading}
        decoding="async"
        onContextMenu={(e) => e.preventDefault()}
        onDragStart={(e) => e.preventDefault()}
        className={imgClassName}
      />
    </div>
  );
};

export default ProtectedImage;
